import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { Certificacion } from 'src/app/interfaces/certificacion';
import { Experiencia } from 'src/app/interfaces/experiencia';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { CertificacionService } from 'src/app/services/certificacion/certificacion.service';

@Component({
  selector: 'app-certificate-candidate',
  templateUrl: './certificate-candidate.component.html',
  styleUrls: ['./certificate-candidate.component.scss']
})
export class CertificadeCandidateComponent implements OnInit {

  usuario: JwtResponse;
  certifiaciones: Certificacion[];
  certificacionCandidato: Certificacion;
  mostrarEdicion: boolean;
  noPagina: number;
  formCer: FormGroup;
  editarCertificacion: boolean;
  mostrarCertificacion: boolean;

  constructor(private certificacionService: CertificacionService, private modalService: NgbModal, 
    private formBuilder: FormBuilder) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.certificacionCandidato = {} as Certificacion;
    this.editarCertificacion = false;
    this.mostrarCertificacion = false;
  }

  ngOnInit() {
    this.noPagina = 1;
    this.cargarExperienciasCandidato();
    this.crearFormularioExperiencia();
  }

  crearFormularioExperiencia(): void {
    this.formCer = this.formBuilder.group({
      nombre: [null, Validators.required],
      empresa: [null, Validators.required],
      anio: [null, [Validators.maxLength(4), Validators.pattern(/^([0-9])*$/)]]
    });
  }

  async cargarExperienciasCandidato() {
    try {
      if(this.usuario && this.usuario.user){
        const response = await this.certificacionService.obtenerCertificacionesPorIdCandidato(this.usuario.user.idUsuario);
        this.certifiaciones = response.data;
        if(this.certifiaciones.length == 0){
          this.mostrarEdicion = true;
        }
      } 
    } catch (error) {
      console.error("Error al cargar las experiencias del canidato", error);
    }
  }

  validarExperiencia(): void {
    if(this.certificacionCandidato && this.certificacionCandidato.idCertificacion){
      this.actualizarCertificacionCandidato();
    }else{
      if(this.formCer.valid){
        this.registrarCertificacionCandidato();
      }
    }
  }

  registrarCertificacionCandidato(){
    const certificacion: Certificacion = {
      idCertificacion: null,
      nombre: this.formCer.get('nombre').value,
      empresa: this.formCer.get('empresa').value,
      anio: this.formCer.get('anio').value
    };

    this.certificacionService.registrarCertificacion(this.usuario.user.idUsuario, certificacion).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar la certificación del candidato: ', result.messageError);
      }
    });
  }

  actualizarCertificacionCandidato(){
    const ceritificacion: Certificacion = {
      idCertificacion: this.certificacionCandidato.idCertificacion,
      nombre: this.formCer.get('nombre').value || this.certificacionCandidato.nombre,
      empresa: this.formCer.get('empresa').value || this.certificacionCandidato.empresa,
      anio: this.formCer.get('anio').value || this.certificacionCandidato.anio
    };

    this.certificacionService.actualizarCertificaciones(this.usuario.user.idUsuario, ceritificacion).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.certificacionCandidato = {} as Certificacion;
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizado la certificación del candidato: ', result.messageError);
      }
    });
  }

  eliminarCertificacionCandidato(idExperiencia: number): void {
    if(this.usuario && this.usuario.user.idUsuario && idExperiencia){
      this.certificacionService.eliminarCertificacionPorId(this.usuario.user.idUsuario, idExperiencia).pipe(
        catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })
      ).subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mostrarEdicion = false;
          this.abrirModalMessage("Éxito", "Se ha eliminado correctamente.");
        } else {
          this.abrirModalMessage("Error", "No se ha eliminado correctamente " + result.messageError);
          console.error('Error al eliminar la certificación del candidato: ', result.messageError);
        }
      });
    }
  }

  habilitarEdicion(certificacion: Certificacion): void{
    this.certificacionCandidato = {} as Certificacion;
    if(certificacion){
      this.mostrarEdicion = true;
      this.editarCertificacion = true;
      this.certificacionCandidato = certificacion;
    }
  }

  mostrarEdicionCertificacion(): void {
    this.mostrarEdicion = true;
    this.editarCertificacion = false;
    this.certificacionCandidato = {} as Certificacion;
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  mostrarCertificacionData(): void {
    this.mostrarCertificacion = !this.mostrarCertificacion;
  }

  cerrarCertificacionData(): void {
    this.mostrarCertificacion = false;
  }
}
